const Class = require('sma.fs/chide/class');
const chide = require('sma.fs/chide/ui');
const Fields = require('sma.fs/surveys/fields');
const Option = require('sma.fs/surveys/options').Option;
const modals = require('sma.common/components/modals');
const Survey = require('sma.fs/surveys/editor').Survey;

const Branching = $.klass({});

Branching.Simple = $.klass({
	getChoicesForField: function (field) {
		return this.getChoicesForPage(field.page.index);
	},

	getChoicesForPage: function (page) {
		const choices = [
			[-1, '---']
		];
		const survey = Survey.instances[0];

		$.each(survey.pages.slice(page + 1), function (_i) {
			choices.push([
				this.id,
				interpolate(gettext('Page %(page_label)s'), {
					page_label: ((this.label && this.label.length)
						? survey.editor.languages.translate(this.label, survey.editor.languages.selected())
						: this.index + 1)
				}, true)
			]);
		});

		choices.push(['terminate', gettext('Termination Page')]);
		choices.push(['finish', gettext('The Finish Page')]);

		return choices;
	},

	isValid: function (field) {
		let result = true;
		if (field.choices) {
			$.each(field.choices.value, function (i, value) {
				if (value.branching && value.branching.value != '' && value.branching.value <= field.page.index) {
					result = false;
				}
			});
		}
		return result;
	},

	reset: function (field) {
		if (field.choices) {
			$.each(field.choices.value, function (i, value) {
				if (value.branching) {
					value.branching.value = '';
				}
			});
		}
	}
});

Branching.Simple.Rule = Class.create(chide.opts.Single, {
	enabled: true,
	label: gettext('Branch to'),
	help: gettext('About Simple Branching - Simple branching allows you to skip the survey to a different page based on the responses to this question.'),
	renderChoices: function () {
		return (this.page || this.field.page).getBranchingSelect();
	},
	changed: function (val) {
		if (val) {
			$('#page-skip-image').show();
		}
	},
	getPage: function () {
		const e = (this.page || this.field.page);

		const page = Fields.Helpers.getPageIndexByPageId(this.value);

		if (page === undefined || page === '' || page === '-1') {
			return undefined;
		}

		if (parseInt(page, 10) === page
			&& (page < e.index || page >= Survey.instances[0].pages.length)) {
			return undefined;
		}

		return page;
	}
});

const Extraction = $.klass(Option.Value, {
	classes: 'option',
	help: gettext('About Extraction - The choices for this question are determined based on a user\'s answers to a previous question. The question to be extracted from must have an identifier assigned to it.'),

	initialize: function($super, field, config) {
		let Survey = require('sma.fs/surveys/editor').Survey;

		var that = this;
		this.survey = Survey.instances[0];

		$super(field, config);
		this.config = config;
		if (!this.value || !this.value.question) {
			this.value = undefined;
		}

		this.question = new Option.Radio(field, {
			classes: 'option',
			display: 'dropdown',
			value: (this.value) ? this.value.question : undefined,

			getField: function() {
				return (this.value) ? this.editor.survey.nameMapping[this.value] : undefined;
			},

			changed: function(value) {
				if (value) {
					var field = that.editor.survey.nameMapping[value];
					that.value = { question: value };
					that.setExtractionOptions(field);
				} else {
					that.value = undefined;
					that.options = undefined;
					that.optionsPlaceholder.hide().empty();
					that.choiceOptionsPlaceholder.hide();
				}
			}
		});

		this.extractChoicesUI = new chide.opts.Checkbox( {
			value : (this.value) ? this.value.extractChoices : false,
			label: gettext('Extract Choices'),
			help: gettext('About Extract Choices - If selected, this will extract choices from a dropdown menu or MC question instead of the variable label.')
		});

		this.setSelectChoices = new chide.opts.Select( {
			label: '<strong>' + gettext('Extraction Variable: ') + '</strong>',
			help: gettext('Extraction Variable - The variables for this question are determined based on a user\'s answers to a previous question. Select a variable to see available options for it.'),

			renderChoices: function(values) {
				var choices = [];
				var values = that.question.getField().getExtractionChoices();
				var lang = that.survey.editor.languages.selected();
				this.value = undefined;

				$.each(values, function(pos, name) {
					if (typeof name[1] == 'object') {
						choices.push([name[0], name[1][lang]]);
					} else {
						choices.push([name[0], name[1]]);
					}
				});

				return chide.opts.renderSelect(choices, '---');
			},

			changed: function(value) {
				if (value) {
					that.choiceOptionsPlaceholder.empty();
					that.choiceOptionsPlaceholder.show();
					that.choiceOptionsPlaceholder.append(that.textlist.renderSubOptions(that.textlist.value[value],value).show());
				} else {
					that.choiceOptionsPlaceholder.empty();
					that.choiceOptionsPlaceholder.hide();
				}
			}
		});

		this.options = undefined;
	},

	setExtractionOptions: function(field, value) {
		try {
			this.options = field.getExtractionOptions(value);
		} catch (e) {
			this.options = field.getExtractionOptions();
		}
		this.choices = field.getExtractionChoices();

		if (this.options) {
			this.optionsPlaceholder
				.empty()
				.append('<h4>' + gettext('Extraction Options') + '<\/h4>')
				.append(this.options.render())
				.append(this.extractChoicesUI.render());

			if (this.choices) {
				this.optionsPlaceholder.append(this.setSelectChoices.render(this.choices, '---'));
			}
			// Show default options
			this.optionsPlaceholder.show();
		}
	},

	serialize: function() {
		if (this.question.value) {
			var question = this.question.getField();

			if (!question) {
				return;
			}

			var serialized = {
				question: this.question.value
			};

			if (this.options || this.value.options) {
				serialized.options = (this.options) ? this.question.getField().serializeExtractionOptions(this.options) : this.value.options;
				serialized.extractChoices = (this.extractChoicesUI) ? this.extractChoicesUI.value || false : false;
			}

			return serialized;
		}
	},

	render: function($super) {
		var that = this;
		this.question.choices = [['', '---']];

		$.each(this.editor.survey.nameMapping, function(name, field) {
			if (field.page.index < that.field.page.index && field.extractable) {
				that.question.choices.push([name, name]);
			}
		});

		this.questionDisplay = this.question.render()
			.prepend('<strong>' + gettext('Extraction Source: ') + '<\/strong>');

		if (!this.optionsPlaceholder) {
			this.optionsPlaceholder = (new Option.Group(this.field, {classes: 'option-group'})).render().hide();
		}

		if (!this.choiceOptionsPlaceholder) {
			this.choiceOptionsPlaceholder = (new Option.Group(this.field, {classes: 'option-group'})).render().hide();
		} else {
			that.choiceOptionsPlaceholder.empty();
			that.choiceOptionsPlaceholder.hide();
		}

		var options = (this.options) ? this.question.getField().serializeExtractionOptions(this.options) : ((this.value) ? this.value.options : undefined);

		if (options) {
			var old_textlist = this.textlist.value;
			this.textlist.updateExtracted(this.question.value);
			this.setExtractionOptions(this.question.getField(), options);
			for (let i=0; i < this.textlist.value.length; i++) {
				for (let j=0; j <old_textlist.length; j++) {
					if (old_textlist[j].text.value[this.survey.editor.languages.selected()] == this.textlist.value[i].text.value[this.survey.editor.languages.selected()]) {
						this.textlist.value[i] = old_textlist[j];
					}
				}
			}
			this.textlist.itemsChanged(this.textlist.value);
		}

		return $super()
			.append(this.questionDisplay.append(this.renderHelpString()))
			.append(this.optionsPlaceholder)
			.append(this.extractChoicesUI)
			.append(this.setSelectChoices)
			.append(this.choiceOptionsPlaceholder);
	}
});

const Looping = $.klass({
	help: '<p>' +
		gettext('Select the pages that will be looped based on the responses to this question.') +
		'<\/p><p>' +
		gettext('Inverted Extraction allows you to loop over all the choices that were <strong>not</strong> selected by a user') +
		'<\/p><p>' +
		gettext('If this is a single text response question, the loop will be iterated with respect to a number given by the respondent.') +
		'</p>',

	initialize: function(survey) {
		this.survey = survey;
		this.loops = {};
	},

	addLoopRule: function(id, loop, using_ids) {
		const that = this;

		this.loops[id] = {};

		if (!using_ids){
			try {
				this.loops[id].range = this.convertRuleToPageIds(loop.range);
			} catch(e) {
				// Looping is no longer valid./ Remove it.
				delete this.loops[id];
				return;
			}
		} else {
			this.loops[id].range = loop.range;
		}

		if (loop.options) {
			this.loops[id].options = loop.options;
		}

		const rule = this.loops[id];

		this.loops[id].serialize = function() {
			const out = {
				options: rule.options,
				range: that.convertRuleToPageIndexes(rule.range)
			};
			return out;
		};
	},

	convertRuleToPageIds: function(range) {
		return [
			Fields.Helpers.getPageIdByPageIndex(range[0]),
			Fields.Helpers.getPageIdByPageIndex(range[1])
		];
	},

	convertRuleToPageIndexes: function(range) {
		return [
			Fields.Helpers.getPageIndexByPageId(range[0]),
			Fields.Helpers.getPageIndexByPageId(range[1])
		];
	},

	convertRules: function() {
		$.each(this.loops, function(name, loop) {
			loop.range[0] = Fields.Helpers.getPageIdByPageIndex(loop.range[0]);
			loop.range[1] = Fields.Helpers.getPageIdByPageIndex(loop.range[1]);
		});
	},

	refreshChoices: function(dropdown, page, skipClear) {
		const that = this;

		if (!skipClear) {
			dropdown.removeOption(/./);
		}

		var min = this.pageMin.val();

		$.each(this.survey.getBranchTargets(page), function() {
			var pageId = this.id;
			var index = this.index;
			var disabled = false;
			var loopedBy = [];

			$.each(that.loops, function(id, val) {
				const question = that.survey.questions[id];
				if (Fields.Helpers.getPageIndexByPageId(val.range[0]) <= index
					&& index <= Fields.Helpers.getPageIndexByPageId(val.range[1]) && id != that.id) {
					disabled = true;
					loopedBy.push(question.name.get());
				}
			});

			if (min != '-1' && this.index < Fields.Helpers.getPageIndexByPageId(min)) {
				return;
			}

			let label;
			if (this.survey) {
				label = this.survey.pages[index].label.display(false);
			} else {
				label = $.format(gettext('Page {0}'), index + 1);
			}

			if (loopedBy.length > 0) {
				label += $.format(gettext(' (Looped by {0})'), loopedBy.join(', '));
			}

			dropdown.addOption(this.id, label, false);

			if (disabled) {
				$('option[value=' + index + ']', dropdown)
					.attr('disabled', 'disabled')
					.addClass('disabled')
					.css('color', '#CCC');
			}


		});
	},

	pageRemoved: function(info) {
		if (!this.loops) {
			return;
		}

		const that = this;

		$.each(info.page.fields, function(i) {
			if (that.loops[this.id] !== undefined){
				delete that.loops[this.id];
			}
		});
	},

	checkLoops: function() {
		const that = this;

		let messages = [];

		$.each(this.loops, function(id, loop) {
			let field = that.survey.questions[id];
			let range = [
				Fields.Helpers.getPageIndexByPageId(loop.range[0]),
				Fields.Helpers.getPageIndexByPageId(loop.range[1])
			];
			if (!field || isNaN(range[0]) || isNaN(range[1])
				|| field.page.index >= range[0]
				|| field.page.index >= range[1])
			{
				messages.push(interpolate('Please note that looping from question "%s" has been removed due to this change.', [field.name.get()]));
				delete that.loops[id];
			}

			if (range[0] > range[1]) {
				loop.range = [loop.range[1], loop.range[0]];
			}
		});

		if (messages.length > 0) {
			alert(messages.join('\n'));
		}
	},

	pageIsLooped: function(page) {
		let index = page.index || page;
		let result = false;

		$.each(this.loops, function(name, loop) {
			if (Fields.Helpers.getPageIndexByPageId(loop.range[0]) <= index
				&& index <= Fields.Helpers.getPageIndexByPageId(loop.range[1])){
				result = true;
				return;
			}
		});

		return result;
	},

	getLoopedQuestions: function(page) {
		let looped = [];
		let that = this;

		if (page === undefined) {
			page = this.survey.currentPage;
		}

		$.each(this.loops, function(id, loop) {
			if (Fields.Helpers.getPageIndexByPageId(loop.range[0]) <= page.index
				&& page.index <= Fields.Helpers.getPageIndexByPageId(loop.range[1])) {
				looped.push({
					page: that.survey.questions[id].page.index,
					field: that.survey.questions[id]
				});
			}
		});

		return looped;
	},

	updateLoopingKeys: function(old, value) {
		if (this.loops[old]) {
			this.loops[value] = {
				range: this.loops[old].range,
				options: this.loops[old].options,
				serialize: this.loops[old].serialize
			};
			delete this.loops[old];
		}
	},

	fieldRemoved: function(key) {
		if (key in this.loops) {
			this.deleteLoop(key);
		}
	},

	deleteLoop: function(value) {
		delete this.loops[value];
	},

	showForQuestion: function(field) {
		const that = this;

		this.name = field.name.value;
		this.id = field.id;

		let looping;

		if (field.id in this.loops) {
			looping = this.loops[field.id];
		}

		let options = field.getExtractionOptions(
			(looping && looping.options)
				? looping.options
				: undefined);

		let pageMinContainer = $('<p>' + gettext('First looped page:') + ' </p>');

		this.pageMin = $('<select></select>', { 'class': 'custom-select' })
			.addOption(-1, '---')
			.change(function() {
				if ($(this).selectedOptions().eq(0).hasClass('disabled')) {
					$(this).val('-1');
				}

				if ($(this).val() == '-1') {
					pageMaxContainer.fadeOut();
				} else {
					that.refreshChoices(that.pageMax, field.editor.survey.pageMapping[$(this).val()].index);
					pageMaxContainer.fadeIn();
				}
			})
			.appendTo(pageMinContainer);

		let pageMaxContainer = $('<p>'+gettext('Last looped page:')+' </p>').hide();

		this.pageMax = $('<select></select>', { 'class': 'custom-select' })
			.appendTo(pageMaxContainer)
			.change(function(){
				if ($(this).selectedOptions().eq(0).hasClass('disabled')){
					$(this).val('-1');
				}
			});

		let dialogContent = $('<div><\/div>')
			.append(this.help)
			.append((options && options.render) ? options.render() : undefined)
			.append('<div class="callout callout-warning">' + gettext('<strong>Warning:</strong> data from looped pages may be deleted when changing this option after collecting responses') + '<\/div>')
			.append(pageMinContainer)
			.append(pageMaxContainer);

		let pages = [];

		this.refreshChoices(that.pageMin, field.page, true);

		if (looping) {
			this.pageMin.val(looping.range[0]);
			this.refreshChoices(that.pageMax, looping.range[0] - 1);
			this.pageMax.val(looping.range[1]);
			pageMaxContainer.show();
		}

		dialogContent.append(pages);

		let dialog = new modals.ContentModal(
			dialogContent, {
				title: gettext('Question Looping'),
				buttons: [{
					label: gettext("Save"),
					cls: 'btn-primary btn-loud',
					handler: () => {
						if (field.qlass == "text-response") {
							if (field.serializeExtractionOptions(options).max < 1) {
								new sma.components.Alert({
									message: gettext('Your form has been saved.'),
									type: 'error'
								});
								return;
							}
						}

						if (that.pageMin.val() != '-1') {
							that.addLoopRule(field.id, {
								range: [that.pageMin.val(), that.pageMax.val()],
								options: field.serializeExtractionOptions(options)
							}, true);
						} else {
							try {
								delete that.loops[field.id];
							} catch (e) {
								// do nothing
							}
						}

						dialog.destroy();
					}
				}]
			}
		);

		dialog.show();
	}
});

const Dynamics = $.klass({
	initialize: function(config) {
		$.extend(this, config);
		if (!this.value){
			this.value = {
				rules: []
			};
		}
	},

	render: function(_triggers){
		this.choices = [
			['current-row', gettext('This row')]
			//['current-column', gettext('This column')] Not implemented
		];
		var that = this;

		$.each(this.survey.nameMapping, function(key, field){
			that.choices.push([key, key]);

			if (!field.isDynamic){
				return;
			}

			if (field.columns != undefined){
				var attr = 'columns';
			}
			else {
				var attr = 'choices';
			}

			$.each(field[attr].value, function(i, variable){
				that.choices.push([key + '[:' + i + ']', key + ' - ' + gettext('Column') + ' ' + (i + 1)]);
			});

			$.each(field.variables.value, function(i, variable){
				that.choices.push([key + '[' + i + ':]', key + ' - ' + gettext('Variable') + ' '  + (i + 1)]);
			});
		});

		if (!_triggers){
			var triggers = (this.field.variables !== undefined) ? this.field.variables.value : this.field.choices.value;
		} else {
			var triggers = _triggers;
		}

		this.triggerOptions = new Dynamics.SelectionHelper(
			this.survey.editor, {
			choices: triggers,
			label_getter: function(choice, i) {return choice.text.get();},
			id_getter: function(choice, i){return i;},
			value: (this.value && this.value.choices) ? this.value.choices : [],
			changed: function(set){
				if (!that.value){
					that.value = { action: 'disable' };
				}
				that.value.choices = $.map(set, function(value){ return parseInt(value,10); });
			}
		});
		$(this).bind('choiceChanged', function(e, choices){
			this.triggerOptions.choices = choices;
			var rendered = this.triggerOptions.render();
			this.triggerOptionsEl.replaceWith(rendered);
			this.triggerOptionsEl = rendered;
		});
		if (this.rendered) {
			this.rendered.remove();
		}

		this.rendered = $('<div><\/div>');
		this.triggerOptionsEl = this.triggerOptions.render();
		this.rendered.append(this.triggerOptionsEl);

		var selector = $('<select><\/select>', { multiple: 'multiple', size: '5' })
			.change(function(e){
				that.value.rules = [];

				var isUnnamedOption = function(val){
					return ['current-row', 'current-column'].indexOf(val) != -1;
				};

				$.each($(this).val(), function(index, value) {
					that.value.rules[index] = {
						target: value,
						action: 'disable',
						exclusive: false
					};
					if (value.split('[').length > 1){
						var question = value.split('[')[0];
						that.value.rules[index].isSamePage = (that.survey.nameMapping[question].page.index == that.survey.currentPage.index);
					} else {
						that.value.rules[index].type = 'question';
						if (isUnnamedOption(value)){
							that.value.rules[index].isSamePage = true;
							that.value.rules[index].exclusive = true;
						}
						else {
							that.value.rules[index].isSamePage = (that.survey.nameMapping[value].page.index == that.survey.currentPage.index);
						}
					}
				});
			});

		$.each(this.choices, function(i, choice) {
			var option = $('<option><\/option>', {
				value: choice[0],
				text: choice[1]
			});

			selector.append(option);
		});

		if (this.value.rules && this.value.rules.length){
			$.each(this.value.rules, function(i, value){
				$('option[value=' + value.target.replace(/([\.\[\]:])/g, "\\$1") + ']', selector).attr('selected', 'selected');
			});
		}

		this.rendered.append($('<div><\/div>', {
			text: gettext('These choices should disable:')
		}).append(selector));

		return this.rendered;
	},

	serializeForVariable: function(variable){
		if (typeof(variable.dynamics) == 'object' && variable.dynamics.value){
			return variable.dynamics.value;
		}
		return [];
	}
});

Dynamics.SelectionHelper = $.klass(Option.Multiple, {
	label: gettext('Choices which should trigger dynamic behaviour:'),
	render: function ($super) {
		return $super().prepend(this.label);
	}
});

module.exports = {
	Looping: Looping,
	Branching: Branching,
	Extraction: Extraction,
	Dynamics: Dynamics
};
